import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { handleAsyncAutoCompleteInputChange } from './common';
import { MultiSelectOption, MultiSelectOptions } from '../state/searchVessel';

interface Props {
  stateSetter: (name: string, value: any) => void;
  value: MultiSelectOptions | MultiSelectOption | undefined;
  name: string;
  isMulti?: boolean;
  customStyle?: any;
  isDisabled?: any;
}

const FOSBSVesselFinder = ({
  isDisabled,
  isMulti,
  customStyle,
  stateSetter,
  value,
  name,
}: Props) => {
  const isCustomStyle = customStyle !== undefined;

  const [inputValue, setInputValue] = useState('');

  const promiseOptions = async (inputValue: any) => {
    return new Promise((resolve, reject) => {
      handleAsyncAutoCompleteInputChange(
        'vessels',
        'vessel_name',
        inputValue,
        true,
        (newOpts: any) => {
          return resolve(
            newOpts.map((el: any) => {
              return { label: `${el.vessel_name} (${el.imo})`, value: el };
            })
          );
        },
        () => {},
        true
      );
    });
  };

  const handleInputChange = (newValue: string) => {
    setInputValue(newValue);
    return inputValue;
  };

  const style1 = {
    control: (base: any, state: any) => {
      return {
        ...base,
        border: '1px solid #ced4da',
        borderRadius: '0px',
        outline: '0',
        transition:
          'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
        borderColor: state.isFocused ? '#ced4da' : '#ced4da',
        boxShadow: state.isFocused
          ? '0 0 0 0.2rem rgba(227, 223, 217, 0.90);'
          : '0 !important',
        '&:hover': { borderColor: '#ced4da' }, // border style on hover
      };
    },
  };

  return (
    <AsyncSelect
      isMulti={isMulti}
      defaultOptions
      isDisabled={isDisabled}
      loadOptions={promiseOptions as any}
      onChange={(vals) => {
        stateSetter(name, vals);
      }}
      value={value}
      placeholder='Type at least 3 characters'
      styles={isCustomStyle ? customStyle : style1}
    />
  );
};

function areEqual(prevProps: Props, nextProps: Props) {
  const equal = prevProps.value === nextProps.value;
  return equal;
}

export default React.memo(FOSBSVesselFinder, areEqual);
